function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.999,
    height: 24,
    viewBox: "0 0 23.999 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17172",
    transform: "translate(-564 -2275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.954 9.924A8.092 8.092 0 0 0 5.895.264a.562.562 0 0 0-.246.939l3.586 3.586L8.3 8.273l-3.484.934-3.585-3.586a.562.562 0 0 0-.939.246 8.1 8.1 0 0 0 9.66 10.059L17.33 23.3a2.256 2.256 0 0 0 3.187 0l2.817-2.816a2.257 2.257 0 0 0 0-3.187z",
    transform: "translate(564.008 2275.037)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 999",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(581 2292)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingService);
export default __webpack_public_path__ + "static/media/settingService.21c1b06784610a2ce09cf96d4c1a4207.svg";
export { ForwardRef as ReactComponent };